@if (content) {
<!-- top outlet -->
<icms-outlet [name]="'Category page / top section'"
             [allowOnly]="['hero-image','quick-links', 'text']"
             [components]="content.topComponents"></icms-outlet>
<cms-category-header-block [category]="category"
                           [variant]="category.categoryHeaderVariant" />
<!-- name row -->
<!-- <div class="wrap"
  *ngIf="content.nameRowVisible">
  <div class="c-4 c-12-set-s c-12-set-m">
    <h1 class="m-t-12 m-t-5-s m-t-8-m"
    sizeClass="SM: h3, XL: h2">{{ category.data?.name }}</h1>
    <read-more *ngIf="category.data?.description"
      class="col-12 m-t-4 block"
      sizeClass="SM: p2, XL: p1"
      [limit]="['80','130','120','100'][client.sizeId]"
      [text]="category.data?.description || ''">
    </read-more>
  </div>
</div> -->
<!-- middle outlet -->
<icms-outlet [name]="'Category page / middle section'"
             [allowOnly]="['hero-image','quick-links', 'text']"
             [components]="content.middleComponents"></icms-outlet>
<!-- listing -->
@if (categoryView.listing) {
<product-listing context="category"
                 class="p-b-8 block"
                 [category]="categoryView.model"
                 [listing]="categoryView.listing"></product-listing>
}
<!-- Bottom components -->
<icms-outlet [name]="'Category page / bottom section'"
             [allow]="['seo-content']"
             [components]="content.bottomComponents"></icms-outlet>
}